import { render, staticRenderFns } from "./order-form-select.vue?vue&type=template&id=50bb6bd0&scoped=true"
import script from "./order-form-select.vue?vue&type=script&lang=js"
export * from "./order-form-select.vue?vue&type=script&lang=js"
import style0 from "./order-form-select.vue?vue&type=style&index=0&id=50bb6bd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb6bd0",
  null
  
)

export default component.exports